import React from 'react';
import FileUploadBadge from '../common/UI/FileUploadBadge';
import OverlayTooltip from '../common/UI/OverlayTooltip';

interface AttachedFilesListProps {
  files: string[];
  maxVisible?: number;
}

const AttachedFilesList: React.FC<AttachedFilesListProps> = ({ files, maxVisible = 2 }) => {
  if (!files || files.length === 0) return null;

  const visibleFiles = files.slice(0, maxVisible);
  const overflowFiles = files.slice(maxVisible);
  const overflowCount = overflowFiles.length;

  return (
    <div
      className="user-msg-attached-files d-flex flex-wrap gap-2 mb-2"
      data-testid="user-msg-attached-files"
    >
      {visibleFiles.map((fileName) => (
        <FileUploadBadge key={fileName} uploadedFileTitle={fileName} showRemoveButton={false} />
      ))}

      {overflowCount > 0 && (
        <OverlayTooltip
          tooltipText={overflowFiles.join('\n')}
          buttonContent={`+${overflowCount}`}
          ariaLabel={`${overflowCount} more attached files`}
          testId="attached-files-overflow-badge"
          tooltipClassName="attached-files-overflow-tooltip"
          buttonClassName="attached-files-overflow-badge"
          placement="bottom"
        />
      )}
    </div>
  );
};

export default AttachedFilesList;
